/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $BulletinList = {
    type: 'array',
    contains: {
        type: 'Bulletin',
    },
} as const;
